import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'picker']

  connect () {
    this.render()
  }

  toggle (event) {
    this.fieldTarget.value = event.target.checked ? this.firstAnswer : ''
    this.render()
    this.fieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  render () {
    const on = Boolean(this.fieldTarget.value)
    this.pickerTarget.classList.toggle('hidden', !on)
    if (this.checkbox) this.checkbox.checked = on
  }

  // Private

  get checkbox () {
    return this.element.querySelector('input[type="checkbox"]')
  }

  get firstAnswer () {
    return Array.from(this.fieldTarget.options).find((option) => option.value)?.value ?? ''
  }
}
